export enum SortingOptions {
    NEWEST = 'newest',
    OLDEST = 'oldest',
    PRICE_ASC = 'priceAsc',
    PRICE_DESC = 'priceDesc',
}